 
import EstimationAndJobForm from '../common/EstimationAndJob/EstimationAndJobForm';
  
const JobForm = () => {
  return (
    <EstimationAndJobForm type="job" />
  )
}
export default JobForm;